import { useState, FormEvent } from "react";
import { ArrowRight, CheckCircle2, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export function WaitlistForm({ compact = false }: { compact?: boolean }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [country, setCountry] = useState("UK");
  const [state, setState] = useState<"idle" | "loading" | "done" | "error">("idle");
  const [message, setMessage] = useState("");

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setState("loading");
    try {
      const { data } = await api.post("/waitlist", { email, name, country });
      setMessage(data.message);
      setState("done");
    } catch (err) {
      setMessage(formatApiError(err));
      setState("error");
    }
  };

  if (state === "done") {
    return (
      <div className="flex items-start gap-3 rounded-2xl border border-brand-emerald/30 bg-emerald-50 p-5 animate-fade-up" data-testid="waitlist-success">
        <CheckCircle2 className="mt-0.5 h-6 w-6 shrink-0 text-brand-emerald" />
        <div>
          <p className="font-heading font-semibold text-brand-navy">Tatenda — you're on the list.</p>
          <p className="text-sm text-brand-slate">{message}</p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={`flex flex-col gap-3 ${compact ? "" : "sm:flex-row sm:items-stretch"}`} data-testid="waitlist-form">
      {!compact && (
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" className="h-12 flex-1 rounded-xl border border-brand-line bg-white px-4 text-sm outline-none ring-brand-blue/30 transition focus:ring-4" data-testid="waitlist-name-input" />
      )}
      <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="h-12 flex-[1.4] rounded-xl border border-brand-line bg-white px-4 text-sm outline-none ring-brand-blue/30 transition focus:ring-4" data-testid="waitlist-email-input" />
      <select value={country} onChange={(e) => setCountry(e.target.value)} className="h-12 rounded-xl border border-brand-line bg-white px-3 text-sm outline-none" data-testid="waitlist-country-select">
        <option value="UK">I'm in the UK</option>
        <option value="US">I'm in the US</option>
        <option value="Other">Elsewhere</option>
      </select>
      <button type="submit" disabled={state === "loading"} className="inline-flex h-12 items-center justify-center gap-2 rounded-xl bg-brand-blue px-6 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-brand-blueHover disabled:opacity-60" data-testid="waitlist-submit-button">
        {state === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Join waitlist <ArrowRight className="h-4 w-4" /></>}
      </button>
      {state === "error" && <p className="text-sm text-red-600 sm:basis-full" data-testid="waitlist-error">{message}</p>}
    </form>
  );
}
